"use strict";
exports.__esModule = true;
var ramda_1 = require("ramda");
exports["default"] = ramda_1.pick([
    'accept-charset',
    'action',
    'autocomplete',
    'enctype',
    'method',
    'post',
    'name',
    'novalidate',
    'target',
]);
//# sourceMappingURL=form.js.map